import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { Field } from 'redux-form';
import { Slider, Input } from '../../../common/components/formControls';
import { withNamespaces } from 'react-i18next';

class Form extends Component {
	componentWillReceiveProps(nextProps) {
		if (this.props.currentFormValues) {
			const calculatedFields = this.getCalculatedFields(nextProps.currentFormValues);
			Object.keys(calculatedFields).forEach(field => {
				const nextValue = calculatedFields[field];
				if (this.props.currentFormValues[field] !== nextValue) {
					this.props.changeFormValue(field, nextValue);
				}
			});
		}
	}

	getCalculatedFields(values) {
		const calculatedFields = {
			vestibularFunctionTotal: [...Array(10).keys()].map(x => values[`vestibularFunction_${x + 1}`]).reduce((acc, current) => acc + (current || 0), 0),
			auditoryFunctionTotal: [...Array(10).keys()].map(x => values[`auditoryFunction_${x + 1}`]).reduce((acc, current) => acc + (current || 0), 0),
			visualDysfunctionTotal: [...Array(10).keys()].map(x => values[`visualDysfunction_${x + 1}`]).reduce((acc, current) => acc + (current || 0), 0),
			proprioceptiveFunctionTotal: [...Array(10).keys()].map(x => values[`proprioceptiveFunction_${x + 1}`]).reduce((acc, current) => acc + (current || 0), 0),
			hypotactileSymptomTotal: [...Array(10).keys()].map(x => values[`hypotactileSymptom_${x + 1}`]).reduce((acc, current) => acc + (current || 0), 0),
			hypertactileSymptomTotal: [...Array(10).keys()].map(x => values[`hypertactileSymptom_${x + 1}`]).reduce((acc, current) => acc + (current || 0), 0),
			hyposensitiveSmellTotal: [...Array(10).keys()].map(x => values[`hyposensitiveSmell_${x + 1}`]).reduce((acc, current) => acc + (current || 0), 0),
			hypersensitiveSmellTotal: [...Array(10).keys()].map(x => values[`hypersensitiveSmell_${x + 1}`]).reduce((acc, current) => acc + (current || 0), 0)
		};

		calculatedFields.total = calculatedFields.vestibularFunctionTotal + calculatedFields.auditoryFunctionTotal + calculatedFields.visualDysfunctionTotal +
			calculatedFields.proprioceptiveFunctionTotal + calculatedFields.hypotactileSymptomTotal + calculatedFields.hypertactileSymptomTotal +
			calculatedFields.hyposensitiveSmellTotal + calculatedFields.hypersensitiveSmellTotal;

		return calculatedFields;
	}

	render() {
		const { t, isReadOnly } = this.props;
		const marks = [...Array(11).keys()].map(x => ({ value: x, label: x }));
		const sliderProps = { min: 0, max: 10, step: 1, marks, valueLabelDisplay: 'on' };

		const colSize = { labelCol: 5, valueCol: 7 };

		const totalColSize = { labelCol: 5, valueCol: 2 };

		const descriptionStyle = {
			marginBottom: '10px'
		};
		const lastDescriptionStyle = {
			marginBottom: '15px'
		};
		const vestibularFunctionFields = [...Array(10).keys()]
			.map(x => <Field key={x} name={`vestibularFunction_${x + 1}`} component={Slider} horizontal label={t(`VestibularFunction_${x + 1}`)} disabled={isReadOnly} {...sliderProps} {...colSize} />);

		const auditoryFunctionFields = [...Array(10).keys()]
			.map(x => <Field key={x} name={`auditoryFunction_${x + 1}`} component={Slider} horizontal label={t(`AuditoryFunction_${x + 1}`)} disabled={isReadOnly} {...sliderProps} {...colSize} />);

		const visualDysfunctionFields = [...Array(10).keys()]
			.map(x => <Field key={x} name={`visualDysfunction_${x + 1}`} component={Slider} horizontal label={t(`VisualDysfunction_${x + 1}`)} disabled={isReadOnly} {...sliderProps} {...colSize} />);

		const proprioceptiveFunctionFields = [...Array(10).keys()]
			.map(x => <Field key={x} name={`proprioceptiveFunction_${x + 1}`} component={Slider} horizontal label={t(`ProprioceptiveFunction_${x + 1}`)} disabled={isReadOnly} {...sliderProps} {...colSize} />);

		const hypotactileSymptomFields = [...Array(10).keys()]
			.map(x => <Field key={x} name={`hypotactileSymptom_${x + 1}`} component={Slider} horizontal label={t(`HypotactileSymptom_${x + 1}`)} disabled={isReadOnly} {...sliderProps} {...colSize} />);

		const hypertactileSymptomFields = [...Array(10).keys()]
			.map(x => <Field key={x} name={`hypertactileSymptom_${x + 1}`} component={Slider} horizontal label={t(`HypertactileSymptom_${x + 1}`)} disabled={isReadOnly} {...sliderProps} {...colSize} />);

		const hyposensitiveSmellFields = [...Array(10).keys()]
			.map(x => <Field key={x} name={`hyposensitiveSmell_${x + 1}`} component={Slider} horizontal label={t(`HyposensitiveSmell_${x + 1}`)} disabled={isReadOnly} {...sliderProps} {...colSize} />);

		const hypersensitiveSmellFields = [...Array(10).keys()]
			.map(x => <Field key={x} name={`hypersensitiveSmell_${x + 1}`} component={Slider} horizontal label={t(`HypersensitiveSmell_${x + 1}`)} disabled={isReadOnly} {...sliderProps} {...colSize} />);

		return <div>
			<Panel>
				<Panel.Heading>{t('VestibularFunction_Title')}</Panel.Heading>
				<Panel.Body>
					<div style={descriptionStyle}>{t('VestibularFunction_Description')}</div>
					<div style={descriptionStyle}>{t('VestibularFunction_Example')}</div>
					<div style={descriptionStyle}>{t('VestibularFunction_Example1')}</div>
					<div style={lastDescriptionStyle}>{t('VestibularFunction_Example2')}</div>
					{vestibularFunctionFields}
					<Field name='vestibularFunctionTotal' component={Input} horizontal type='text' label={t('Total')} disabled {...totalColSize} />
				</Panel.Body>
			</Panel>

			<Panel>
				<Panel.Heading>{t('AuditoryFunction_Title')}</Panel.Heading>
				<Panel.Body>
					<div style={descriptionStyle}>{t('AuditoryFunction_Description')}</div>
					{auditoryFunctionFields}
					<Field name='auditoryFunctionTotal' component={Input} horizontal type='text' label={t('Total')} disabled {...totalColSize} />
				</Panel.Body>
			</Panel>

			<Panel>
				<Panel.Heading>{t('VisualDysfunction_Title')}</Panel.Heading>
				<Panel.Body>
					<div style={descriptionStyle}>{t('VisualDysfunction_Description')}</div>
					{visualDysfunctionFields}
					<Field name='visualDysfunctionTotal' component={Input} horizontal type='text' label={t('Total')} disabled {...totalColSize} />
				</Panel.Body>
			</Panel>

			<Panel>
				<Panel.Heading>{t('ProprioceptiveFunction_Title')}</Panel.Heading>
				<Panel.Body>
					<div style={descriptionStyle}>{t('ProprioceptiveFunction_Description')}</div>
					{proprioceptiveFunctionFields}
					<Field name='proprioceptiveFunctionTotal' component={Input} horizontal type='text' label={t('Total')} disabled {...totalColSize} />
				</Panel.Body>
			</Panel>

			<Panel>
				<Panel.Heading>{t('TactileFunction_Title')}</Panel.Heading>
				<Panel.Body>
					<div style={descriptionStyle}>{t('TactileFunction_Description')}</div>
					<h4>{t('HypotactileSymptoms')}</h4>
					{hypotactileSymptomFields}
					<Field name='hypotactileSymptomTotal' component={Input} horizontal type='text' label={t('Total')} disabled {...totalColSize} />
					<h4>{t('HypertactileSymptoms')}</h4>
					{hypertactileSymptomFields}
					<Field name='hypertactileSymptomTotal' component={Input} horizontal type='text' label={t('Total')} disabled {...totalColSize} />
				</Panel.Body>
			</Panel>

			<Panel>
				<Panel.Heading>{t('OlfactoryFunction_Title')}</Panel.Heading>
				<Panel.Body>
					<div style={descriptionStyle}>{t('OlfactoryFunction_Description')}</div>
					<h4>{t('HypersensitiveSmell')}</h4>
					{hypersensitiveSmellFields}
					<Field name='hypersensitiveSmellTotal' component={Input} horizontal type='text' label={t('Total')} disabled {...totalColSize} />
					<h4>{t('HyposensitiveSmell')}</h4>
					{hyposensitiveSmellFields}
					<Field name='hyposensitiveSmellTotal' component={Input} horizontal type='text' label={t('Total')} disabled {...totalColSize} />
				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Heading>{t('TotalAll')}</Panel.Heading>
				<Panel.Body>
					<Field name='total' component={Input} horizontal type='text' label={t('Total')} disabled {...totalColSize} />
				</Panel.Body>
			</Panel>
		</div>;
	}
}

export default withNamespaces(props => props.resourcesNamespace)(Form);

export const RequiredFields = [
];